import React from "react";
import { useDomains } from "../../hooks/useDomains";
import InputModal from "./InputModal";
import { validateDomain } from "../../helpers/utils";
import { usePublisherContext } from "../../hooks/usePublisherProvider";

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
  onSubmit: (domain: string, createAdUnits: boolean) => void;
  title?: string;
  label?: string;
  showCheckbox?: boolean;
  createOptions: Parameters<ReturnType<typeof useDomains>["create"]>[1];
  asAdmin?: boolean;
} & React.ComponentProps<typeof InputModal>;
export default function CreatePropertyModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  label,
  createOptions,
  showCheckbox,
  asAdmin,
}: Props) {
  const { create } = useDomains({ enabled: false });
  const [error, setError] = React.useState<string>("");
  const { publisherUsername: username, publisherSlug: slug } =
    usePublisherContext(asAdmin);
  return (
    <InputModal
      elementClassName="create-property-modal"
      title={title || "Create Property"}
      label={label || "Property Name"}
      submitButtonText="Save"
      cancelButtonText="Cancel"
      showCheckbox={showCheckbox}
      checkboxLabel="Create Google Ad Manager Adunits with domain"
      isOpen={isOpen}
      onClose={onClose}
      error={error}
      setError={setError}
      onSubmit={(domain, createAdUnits = false) => {
        if (!validateDomain(domain)) {
          setError("Please enter a valid domain");
          return;
        }
        create({ domain, username, slug, createAdUnits }, createOptions || {});
        onSubmit(domain);
      }}
    />
  );
}
